// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.disc;
  const v$1 = x.title;
  return {
    disc: v !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"disc\""),
    title: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"title\"")
  };
}

function to_json(x) {
  return {
    disc: x.disc,
    title: x.title
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
